// CONTRACT v1 §5a: after a person stops an answer, the next chat request for
// that thread names the stopped stream, so the server stops it first even when
// the stop and the new message arrive out of order (voice mode's
// cancel-then-send and Send now both stop, then send at once).
const REPLACE_WINDOW_MS = 15_000;
const stopped = new Map<string, { streamId: string; at: number }>();

export function rememberStoppedStream(threadId: string, streamId: string, now = Date.now()) {
  stopped.set(threadId, { streamId, at: now });
}

/** One-shot: the request body field for the next send in this thread, if a stop was recent. */
export function replaceStreamBody(
  threadId: string,
  now = Date.now(),
): { replaceStreamId: string } | null {
  const entry = stopped.get(threadId);
  stopped.delete(threadId);
  if (!entry || now - entry.at > REPLACE_WINDOW_MS) return null;
  return { replaceStreamId: entry.streamId };
}
